var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _path, _path2, _circle6, _path3, _circle7, _circle8, _circle9, _circle10, _path4, _circle11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 492,
    viewBox: "0 0 1920 492",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2019_2286)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 492,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1126.23,
    cy: 510.227,
    r: 93.8979,
    fill: "#E4F3FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1126.23,
    cy: 510.227,
    r: 93.8979,
    stroke: "#005EA9",
    strokeWidth: 1.3414
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.482,
    cy: 426.523,
    r: 93.8979,
    fill: "#E4F3FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.482,
    cy: 426.523,
    r: 93.8979,
    stroke: "#005EA9",
    strokeWidth: 1.3414
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.3306,
    cy: 234.032,
    r: 221.331,
    fill: "#E4F3FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1045.38 341.344C1306.15 341.344 1517.55 129.945 1517.55 -130.828C1517.55 -391.601 1306.15 -603 1045.38 -603C784.606 -603 573.207 -391.601 573.207 -130.828C573.207 129.945 784.606 341.344 1045.38 341.344ZM1045.38 215.127C1236.44 215.127 1391.33 60.2383 1391.33 -130.828C1391.33 -321.894 1236.44 -476.783 1045.38 -476.783C854.314 -476.783 699.424 -321.894 699.424 -130.828C699.424 60.2383 854.314 215.127 1045.38 215.127Z",
    fill: "#F2F9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-150.5 559C20.9844 559 160 419.984 160 248.5C160 77.0156 20.9844 -62 -150.5 -62C-321.984 -62 -461 77.0156 -461 248.5C-461 419.984 -321.984 559 -150.5 559ZM-150.5 476C-24.8555 476 77 374.145 77 248.5C77 122.855 -24.8555 21 -150.5 21C-276.145 21 -378 122.855 -378 248.5C-378 374.145 -276.145 476 -150.5 476Z",
    fill: "#EAF4FC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1126.33,
    cy: 320.331,
    r: 221.331,
    fill: "#E4F3FF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2087.5 559C2258.98 559 2398 419.984 2398 248.5C2398 77.0156 2258.98 -62 2087.5 -62C1916.02 -62 1777 77.0156 1777 248.5C1777 419.984 1916.02 559 2087.5 559ZM2087.5 476C2213.14 476 2315 374.145 2315 248.5C2315 122.855 2213.14 21 2087.5 21C1961.86 21 1860 122.855 1860 248.5C1860 374.145 1961.86 476 2087.5 476Z",
    fill: "#EAF4FC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    }
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.02,
    cy: 510.227,
    r: 93.8979,
    fill: "#E4F3FF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.02,
    cy: 510.227,
    r: 93.8979,
    stroke: "#005EA9",
    strokeWidth: 1.3414
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    }
  }, _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1816.23,
    cy: 510.227,
    r: 93.8979,
    fill: "#E4F3FF"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1816.23,
    cy: 510.227,
    r: 93.8979,
    stroke: "#005EA9",
    strokeWidth: 1.3414
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.172 341.344C466.945 341.344 678.344 129.945 678.344 -130.828C678.344 -391.601 466.945 -603 206.172 -603C-54.6013 -603 -266 -391.601 -266 -130.828C-266 129.945 -54.6013 341.344 206.172 341.344ZM206.172 215.127C397.238 215.127 552.127 60.2383 552.127 -130.828C552.127 -321.894 397.238 -476.783 206.172 -476.783C15.1066 -476.783 -139.783 -321.894 -139.783 -130.828C-139.783 60.2383 15.1066 215.127 206.172 215.127Z",
    fill: "#F2F9FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.124,
    cy: 320.331,
    r: 221.331,
    fill: "#E4F3FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2019_2286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 492,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/Background.8124f1a1e2d30619275d61264150ca71.svg";
export { ForwardRef as ReactComponent };